/**
 * Canonical feed/article category labels (Search-Data-Model-Design §4.3 / SDM-20).
 * Feed `category` is an optional search-filter override; empty / none = no override.
 */
export const CANONICAL_FEED_CATEGORIES = [
  'business',
  'finance',
  'politics',
  'news',
  'technology',
  'science',
  'health',
  'environment',
  'investigative',
  'education',
  'justice',
  'general',
];

/** feedWeight steps: 0.0 … 1.0 inclusive. */
export const FEED_WEIGHT_STEPS = Array.from({ length: 11 }, (_, i) =>
  Number((i / 10).toFixed(1)),
);

export function snapFeedWeight(value) {
  const n = Number(value);
  if (Number.isNaN(n)) return 1;
  return Math.round(Math.max(0, Math.min(1, n)) * 10) / 10;
}
